import AddElementModal from './AddElementModal';

import classes from './elements.module.css';

interface PassedProps {
  assetId?: string;
  assetName?: string;
  schemaId?: string;
  label: string;
  isEditDisabled: boolean;
  onBatchCreateAction: (payload: Object) => void;
}

type Props = PassedProps;

const ElementsHeader = ({
  label,
  assetName,
  assetId,
  isEditDisabled = false,
  schemaId,
  onBatchCreateAction,
}: Props) => {
  return (
    <div className={classes.headerContainer}>
      <div className={classes.headerLabel}>{label}</div>
      <div className={classes.headerIcon}>
        {!isEditDisabled && (
          <AddElementModal
            title="Add elements to asset"
            assetId={assetId}
            assetName={assetName}
            schemaId={schemaId}
            // @ts-ignore
            onBatchCreateAction={onBatchCreateAction}
          />
        )}
      </div>
    </div>
  );
};

export default ElementsHeader;
